var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4598 7.29685C16.2031 7.61343 16.9594 8.4453 16.9144 10.1422C16.8548 12.3649 16.8998 14.5889 16.8998 16.911C15.7686 16.6434 14.7049 16.3944 13.6426 16.1401C13.3657 16.0739 13.0836 16.0129 12.8173 15.9162C11.7563 15.5308 10.7178 15.6116 9.65541 15.9493C8.79705 16.2222 7.89233 16.352 7.03396 16.6289C6.09613 16.9309 5.21525 16.9243 4.27211 16.6064C2.87727 16.1361 1.44534 15.7771 0.00546934 15.3639C0.00679397 12.9981 -0.0144001 10.6614 0.0187157 8.32609C0.0279881 7.65715 0.39756 7.1167 0.980398 6.75375C1.83214 6.22257 2.09971 6.34311 2.49578 7.24784C2.76733 7.86644 3.07729 8.51286 3.52766 9.00032C5.08146 10.68 6.70546 12.2947 8.40363 14.0379C10.4263 11.6695 13.0425 10.0772 14.4598 7.29817V7.29685Z",
    fill: "#04D6FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32115 11.9582C7.07997 10.6521 5.87058 9.42679 4.71682 8.14984C3.32199 6.60797 3.16833 4.13356 4.29956 2.35855C5.48511 0.493472 7.65618 -0.318527 9.83123 0.288154C11.8553 0.852447 13.2938 2.7268 13.3428 4.82767C13.3706 6.04765 13.0196 7.12855 12.2487 8.07169C12.0818 8.27701 11.9096 8.47968 11.7202 8.6638C10.6485 9.70893 9.57027 10.7474 8.32115 11.9582ZM8.44566 2.12409C6.86935 2.12277 5.60035 3.39971 5.60565 4.98132C5.61227 6.57353 6.872 7.8412 8.45228 7.84385C10.0101 7.8465 11.3002 6.54306 11.2989 4.9694C11.2989 3.37984 10.0392 2.12542 8.44566 2.12409Z",
    fill: "#04D6FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeMapIcon);
export default __webpack_public_path__ + "static/media/theme-map-icon.a6c43192779335eef9115b306b90c23d.svg";
export { ForwardRef as ReactComponent };